import React, { useContext } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, Grid, TextField } from "@material-ui/core";
import { useFormik } from "formik";
import { useSnackbar } from "notistack";
import DialogTitleComponent from "../../../../components/dialog_title";
import { Agregar } from "../../../../services/request/reclutamiento/seleccionables";
import { FormikInitialValues, FormikValidationSchema } from "./utils";
import { MainContext } from "../../../../App";

export default function DialogAdd(props) {
	const {
		is_open,
		handle_close,
		mutate_discapacidades,
	} = props;

	const { ShowSnackbar } = useContext(MainContext);
	const notistack = useSnackbar();

	const formik = useFormik({
		initialValues: FormikInitialValues,
		validationSchema: FormikValidationSchema,
		onSubmit: async (values, helper) => {
			try {
				notistack.enqueueSnackbar("Agregando la nueva discapacidad...", {
					anchorOrigin: {
						horizontal: "center",
						vertical: "bottom"
					},
				});
				await Agregar(values);
				notistack.closeSnackbar();
				ShowSnackbar("Discapacidad agregada exitosamente.");
			} catch (error) {
				console.error(error);
				ShowSnackbar("Error al intentar agregar la discapacidad.", error);
			} finally {
				helper.resetForm();
				mutate_discapacidades();
				handle_close();
			}
		}
	});

	/**
	 * Método encargado de cerrar el popup y cerrar los paneles.
	 */
	const handleCloseDialog = () => {
		handle_close();
		formik.resetForm();
	}

	return (
		<Dialog open={is_open} onClose={handleCloseDialog} maxWidth="md" PaperProps={{ style: { borderRadius: 20 } }} fullWidth>
			<DialogTitleComponent onClose={handleCloseDialog}>Agregar Discapacidad</DialogTitleComponent>
			<DialogContent>
				<DialogContentText>
					{"Ingrese la información requerida de la discapacidad y luego guarde los cambios."}
				</DialogContentText>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<TextField
							name="valor"
							label="Nombre"
							value={formik.values.valor}
							onChange={formik.handleChange}
							variant="outlined"
							required
							fullWidth
							size="small"
							helperText={formik.errors.valor}
							error={Boolean(formik.errors.valor)}
						/>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
				<Button onClick={formik.submitForm} disabled={formik.isSubmitting} variant="contained" color="primary">Aceptar</Button>
			</DialogActions>
		</Dialog>
	);
}